$(function () {
    var isMobile = GLOBAL.isMobile;
    window.BuyButtonCounter = {
        containerSelector: '.j-buy-button-counter',
        inputSelector: '.j-buy-button-counter-input',
        addSelector: '.j-buy-button-counter-add',
        removeSelector: '.j-buy-button-counter-remove',
        decreaseSelector: '.j-product-decrease',
        increaseSelector: '.j-product-increase',
        counterFieldSelector: '.counter-field',
        counterContainerSelector: '.counter__container',
        counterInputSelector: '.counter__input',
        counterBoxSelector: '.counter__box',
        loaderSelector: '.loader',
        CLASSES: {
          counterInput: 'j-buy-button-counter-input',
          counterAdd: 'j-buy-button-counter-add',
          counterRemove: 'j-buy-button-counter-remove',
          decrease: 'j-product-decrease',
          increase: 'j-product-increase',
          productCounter: 'j-product-counter',
          isLoading: 'is-loading',
          isDisabled: 'is-disabled'
        },
        namespace: 'BuyButtonCounter',
        addedProducts: null,
        ajaxCart:  AjaxCart.getInstance(),
        initialized: false,
        init: function (products) {
            if (products) {
                this.addedProducts = products;
            }
            this.initButtons();
            this.initialized = true;
        },
        initButtons: function() {
            var self = this;

            $(this.containerSelector).each(function() {
                self.initCounterEvents($(this));
            });
        },
        initCounterEvents: function($counter) {
            var self = this,
                productId = $counter.data('id'),
                $add = $counter.find(self.addSelector),
                $remove = $counter.find(self.removeSelector),
                $input = $counter.find(self.inputSelector),
                minQuantity = Number($input.data('min')),
                maxQuantity = Number($input.data('max')),
                step = Number($input.data('step')),
                quantity = Number($input.val()),
                addTimer;

            $add
                .off('click.' + self.namespace)
                .on('click.' + self.namespace, function () {

                    if (self.isButtonEnabled($add) || quantity < maxQuantity) {
                        quantity += step;

                        if (quantity > maxQuantity) {
                            quantity = maxQuantity;
                        } else if (quantity < minQuantity) {
                            quantity = minQuantity;
                        }

                        $input.val(quantity);

                        if (quantity === maxQuantity) {
                            self.disableButton($add);
                        }

                        $counter.addClass('is-visible');
                        self.enableButton($remove);

                        clearTimeout(addTimer);
                        addTimer = setTimeout(function () {
                            self.setQuantity(productId, quantity)
                        }, 300);
                    }

                    if (quantity >= maxQuantity) {
                        self.trigger('onLimitReached');
                    }
                });

            $remove
                .off('click.' + self.namespace)
                .on('click.' + self.namespace, function () {

                    if (self.isButtonEnabled($remove) && quantity > 0) {
                        quantity -= step;

                        if (quantity < minQuantity) {
                            quantity = 0;
                        }

                        $input.val(quantity);

                        if (quantity === 0) {
                            self.trigger('onBeforeRemove', $counter);
                            self.disableButton($remove);
                            $counter.removeClass('is-visible');
                        }

                        self.enableButton($add);

                        clearTimeout(addTimer);
                        addTimer = setTimeout(function () {
                            self.setQuantity(productId, quantity)
                        }, 500);
                    }
                });

            $input
                .numberMask({type: 'int'})
                .off('change.' + self.namespace)
                .on('change.' + self.namespace, function () {

                    quantity = $input.val() * 1;

                    if (quantity === 0) {
                        self.trigger('onBeforeRemove', $counter);
                        $input.val(0);
                        self.disableButton($remove);
                        self.enableButton($add);
                        $counter.removeClass('is-visible');
                        self.removeProduct(productId);
                    } else {
                        if (quantity < minQuantity) {
                            quantity = minQuantity;
                        } else if (quantity >= maxQuantity) {
                            $input.val(maxQuantity);
                            quantity = maxQuantity;
                            $add.addClass('__disabled');
                        } else if(quantity % step !== 0) {
                            quantity = (quantity - quantity % step) + step;
                            $input.val(quantity);
                        }

                        $remove.removeClass('__disabled');
                        $counter.addClass('is-visible');
                        self.setQuantity(productId, quantity);
                    }
                })
                .off('focus.' + self.namespace)
                .on('focus.' + self.namespace, function () {
                    $counter.addClass('is-visible');
                })
                .off('blur.' + self.namespace)
                .on('blur.' + self.namespace, function () {
                    if ($input.val() * 1 === 0) {
                        $counter.removeClass('is-visible');
                    }
                });

                $(`#j-buy-button-counter-${productId}`).productCounter({
                  disabledClass: isMobile ? 'is-disabled' : '__disabled',
                  onQuantityChange: function (quantity) {
                    $(`#j-buy-button-widget-${productId}`).attr('data-quantity', quantity * 1);
                  },
                  onLimitReached: function () {
                    if (!isMobile) return
                    window.App.notifications.fire(l10n('Больше нет в наличии'));
                  }
                });
        },

        updateButton: function (product, quantity) {
            var $counter = $('#j-buy-button-counter-' + product.id),
                $input = $counter.find(this.inputSelector),
                $add = $counter.find(this.addSelector),
                $remove = $counter.find(this.removeSelector);

            if (!$counter.length) {
                return;
            }

            if (quantity) {
                $input.val(quantity);
                $counter.addClass('is-visible');
                this.enableButton($remove);
                if (product.quantity === product.max_quantity) {
                    this.disableButton($add);
                } else {
                    this.enableButton($add);
                }
            } else {
                $input.val(0);
                $counter.removeClass('is-visible');
                this.disableButton($remove);
            }
            this.initCounterEvents($counter);
        },

        updateCounter: function (id) {
            var self = this;

            var $oldCounter = $('#j-buy-button-counter-' + id);
            if (!$oldCounter.length || $oldCounter.is('.j-ajax-ignore')) {
              return;
            }
            var $newCounter = $oldCounter.clone();

            isMobile
              ? this.setCounterOnMobile($newCounter, self.isProductInCart(id))
              : this.setCounterOnDesktop($newCounter, self.isProductInCart(id))

            $oldCounter.replaceWith($newCounter);
            self.initCounterEvents($newCounter);
        },

        setCounterOnDesktop: function (counterEl, isProductInCart) {
          var self = this;
          if (isProductInCart) {
            counterEl.find(self.counterFieldSelector)
              .removeClass(self.CLASSES.productCounter).addClass(self.CLASSES.counterInput);

            counterEl.find(self.decreaseSelector)
              .removeClass(self.CLASSES.decrease).addClass(self.CLASSES.counterRemove);

            counterEl.find(self.increaseSelector)
              .removeClass(self.CLASSES.increase).addClass(self.CLASSES.counterAdd);
          } else {
            counterEl.find(`${self.counterFieldSelector}, ${self.counterContainerSelector}`).removeClass(self.CLASSES.isDisabled);

            counterEl.find(self.removeSelector)
              .removeClass(`${self.CLASSES.counterRemove} ${self.CLASSES.isDisabled}`).addClass(self.CLASSES.decrease);

            counterEl.find(self.inputSelector)
              .removeClass(self.CLASSES.counterInput).addClass(self.CLASSES.productCounter).val(1);

            counterEl.find(self.addSelector)
              .removeClass(self.CLASSES.counterAdd).addClass(self.CLASSES.increase);
            
            counterEl.find(self.loaderSelector).remove();
          }
        },

        setCounterOnMobile: function (counterEl, isProductInCart) {
          var self = this;
          if (isProductInCart) {
            counterEl.find(self.counterInputSelector)
              .removeClass(self.CLASSES.productCounter).addClass(self.CLASSES.counterInput);

            counterEl.find(self.decreaseSelector)
              .removeClass(self.CLASSES.decrease).addClass(self.CLASSES.counterRemove);

            counterEl.find(self.increaseSelector)
              .removeClass(self.CLASSES.increase).addClass(self.CLASSES.counterAdd);
          } else {
            counterEl.find(self.inputSelector)
              .removeClass(self.CLASSES.counterInput).addClass(self.CLASSES.productCounter).val(1);

            counterEl.find(self.removeSelector)
              .removeClass(self.CLASSES.counterRemove).addClass(self.CLASSES.decrease);

            counterEl.find(self.addSelector)
              .removeClass(self.CLASSES.counterAdd).addClass(self.CLASSES.increase);

            counterEl.find(self.counterBoxSelector).removeClass(self.CLASSES.isLoading);
          }
        },

        setQuantity: function(id, quantity) {
            var product = this.ajaxCart.getProductById(id);

            if (quantity === 0) {
                this.removeProduct(id);

                return;
            }

            if (product) {
                this.ajaxCart.Cart.setProductQuantityByHash(product.hash, quantity);
                this.trigger('onChange', product, quantity);
            } else {
                this.addProduct(id, quantity);
            }
        },

        addProduct: function (id, quantity) {
            var gift = $('#j-buy-button-counter-' + id).data('gift') * 1;
            var related = [];
            var product = {
                type: 'product',
                quantity: quantity,
                id: id
            };

            if (gift) {
                related = [{type: 'gift', quantity: 1, id: gift}];
                product.type = 'gift_parent';
            }

            if (this.trigger('onBeforeAdd', product, related) !== false) {
                AjaxCart.openCartOnAdd = false;
                this.ajaxCart.appendProduct(product, related);
                this.trigger('onChange', product, quantity);
                this.trigger('onAfterAdd', product, related);
            }
        },

        removeProduct: function (id) {
            var product = this.ajaxCart.getProductById(id);

            if (product) {
                this.ajaxCart.Cart.removeProductByHash(product.hash);
                this.trigger('onChange', product);
            }
        },

        updateOrderSum: function (product, quantity) {
            var $product = $('.j-product-row[data-id="' + product.id + '"]');
            var $orderSum = $product.find('.j-product-order-sum');

            if (quantity) {
                $orderSum.html(priceFormat(quantity * product.price));
                $product.addClass('__inCart');
            } else {
                $orderSum.empty();
                $product.removeClass('__inCart');
            }
        },

        disableButton: function ($button) {
            $button.addClass('__disabled is-disabled');
        },

        enableButton: function ($button) {
            $button.removeClass('__disabled is-disabled');
        },

        isButtonEnabled: function ($button) {
            return !$button.hasClass('__disabled') && !$button.hasClass('is-disabled');
        },

        isProductInCart: function(id) {
          return Object.values(AjaxCart.getInstance().Cart.products).some(product => product.id === Number(id) && !product.related_to);
        }
    };

    var ajaxCart = AjaxCart.getInstance();
    var cart = ajaxCart.Cart;
    
    if (cart && cart.initialized && !BuyButtonCounter.initialized) {
        BuyButtonCounter.init(ajaxCart.products);
    }
    
    ajaxCart.attachEventHandlers({
        onInit: function() {
            if (BuyButtonCounter.initialized) return;
            BuyButtonCounter.init(this.products);
        },
        onProductChange: function(hash, quantity) {
            var product = this.getProductByHash(hash);

            BuyButtonCounter.updateButton(product, quantity);
            BuyButtonCounter.updateOrderSum(product, quantity);
        },
        onQuantityChange: function (product) {
            BuyButtonCounter.updateOrderSum(product, product.quantity);
        },
        onProductAdd: function (id, product) {
            BuyButtonCounter.updateCounter(id);
            BuyButtonCounter.updateButton(product, product.quantity);
            BuyButtonCounter.updateOrderSum(product, product.quantity);
        },
        onProductRemove: function (id) {
            BuyButtonCounter.updateCounter(id);
        }
    });

    $.extend(BuyButtonCounter, TMEvents);

    BuyButtonCounter.attachEventHandler('onChange', function (product, quantity) {
        BuyButtonCounter.updateOrderSum(product, quantity);
    });
});
